import { PropsWithChildren } from "react";
import Sidebar, { SidebarProps } from "./Sidebar";
import { MobileNavButton } from "./MobileNavButton";
import RecoveryBanners from "./common/RecoveryBanners";
import { AppHeader } from "./redesign/AppHeader";
import { cn } from "@/lib/utils";

interface BasePageProps extends SidebarProps {
  contentClassName?: string;
}

export const BasePage = ({
  activeItem = "home",
  children,
  contentClassName,
}: PropsWithChildren<BasePageProps>) => {
  return (
    <div className="flex h-full min-h-0 w-full overflow-hidden bg-white">
      {/* Sidebar — collapses to an icon rail (md) and hides below md */}
      <Sidebar activeItem={activeItem} />
      <div className="flex min-w-0 flex-1 flex-col overflow-hidden bg-[#f4f4f6]">
        <AppHeader />
        <RecoveryBanners />
        <div
          className={cn("min-h-0 flex-1 overflow-auto pt-4 md:pt-6", contentClassName)}
          data-page-scroll
        >
          {/* Below md the sidebar is hidden; a hamburger opens it in a drawer */}
          <div className="md:hidden px-4 sm:px-6 mb-3">
            <MobileNavButton activeItem={activeItem} />
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};
